import React, { useEffect, useReducer } from "react";
import { TextYearName, Wrapper } from "./index.style";
import {
    Button,
    ChevronEndIcon,
    ChevronStartIcon,
    Flex,
} from "@fluentui/react-northstar";
import {
    ACTION_TYPES_SLIDER_YEAR,
    INIT_SLIDE_YEAR,
    reducerSliderYear,
} from "../../reducers/reducer.slider_year";
import { useTranslation } from "react-i18next";
import { I18N_NS_TIME_REPORTING } from "../../constants";
import moment from "moment";
import styled, { css } from "styled-components";

const SliderYears = ({ onChangeYear = () => null, defaultYear }) => {
    const { t } = useTranslation(I18N_NS_TIME_REPORTING);
    const current_year = Number(moment().format("YYYY"));
    const [state, dispatch] = useReducer(
        reducerSliderYear,
        defaultYear ? { year: defaultYear } : INIT_SLIDE_YEAR
    );

    useEffect(() => {
        onChangeYear({
            year: state.year,
        });
    }, [state.year]);

    return (
        <Wrapper vAlign="center" gap="gap.large">
            <Flex>
                <TextYearName
                    content={t("v2.year_tracking.slider.year", {
                        year: state.year,
                    })}
                />
            </Flex>
            <Flex>
                <SButton
                    icon={<ChevronStartIcon size="small" />}
                    iconOnly
                    flat
                    onClick={() => {
                        return dispatch({
                            type: ACTION_TYPES_SLIDER_YEAR.decrement,
                        });
                    }}
                    $left={true}
                />
                <SButton
                    icon={<ChevronEndIcon size="small" />}
                    iconOnly
                    flat
                    disabled={Number(state.year) >= current_year}
                    onClick={() => {
                        return dispatch({
                            type: ACTION_TYPES_SLIDER_YEAR.increment,
                        });
                    }}
                />
            </Flex>
        </Wrapper>
    );
};

export default SliderYears;

const SButton = styled(Button)`
    width: 28px;
    height: 28px;
    border: 1px solid var(--border);
    background: white;
    font-size: 14px;
    color: var(--text-sec) #6b6b80;
    border-radius: ${({ $left }) => ($left ? "4px 0 0 4px" : "0 4px 4px 0")};
    &:hover {
        color: var(--purple);
        border-color: var(--purple);
    }
    ${({ disabled }) =>
        disabled &&
        css`
            cursor: not-allowed;
            opacity: 0.5;
        `}
`;
